import React from "react"

import { StaticFooter, ConsistentlyProvider } from "@fastly/consistently-vanilla"

const Footer = () => {
  return (
    <ConsistentlyProvider reset>
      <StaticFooter />
    </ConsistentlyProvider>
  )
}

export default Footer
